export const content = {
  headline: 'Empfohlene Windsogsicherung',
  stormClips: ['Gesamtanzahl Sturmklammern', 'Stück'],
}
